import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { CreateUserMembershipTypeDto, UserMembershipTypeDto } from '../../../models/user-membership/dto/user-membership.dto';
import { GET_USER_MEMBERSHIP_TYPES_QUERY_KEY } from './useGetUserMembershipTypes';

export const useCreateUserMembershipType = (organizationId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['createUserMembershipType', organizationId],
        mutationFn: async (body: CreateUserMembershipTypeDto) => {
            const response = await apiClient.fetchApi<UserMembershipTypeDto, CreateUserMembershipTypeDto>({ method: 'POST', endpoint: `organizations/${organizationId}/membershipTypes`, body });
            return response
        },
        onSuccess: (data: UserMembershipTypeDto) => {
            queryClient.setQueryData<UserMembershipTypeDto[]>(GET_USER_MEMBERSHIP_TYPES_QUERY_KEY(organizationId), (previousData) => {
                return [...(previousData || []), data];
            });
        }
    });
};